/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
import { FC } from 'react';
import { Link } from 'react-router-dom';

export type BreadcrumbItem = {
  label: string;
  to?: string;
  isActive?: boolean;
};

type BreadcrumbProps = {
  items: BreadcrumbItem[];
};

const Breadcrumb: FC<BreadcrumbProps> = ({ items }) => (
  <nav>
    <ul className="breadcrumb">
      {items.map((item, index) => {
        const isActive = item.isActive || !item.to;
        const isLast = index === items.length - 1;

        return (
          <li
            key={`breadcrumb-${item.label}-${index}`}
            className={`breadcrumb-item ${isActive ? 'active' : ''}`}
            {...(isActive && isLast ? { 'aria-current': 'page' } : {})}
          >
            {isActive || !item.to ? (
              item.label
            ) : (
              <Link to={item.to}>{item.label}</Link>
            )}
          </li>
        );
      })}
    </ul>
  </nav>
);

export default Breadcrumb;
